import { IMember, IDirectoryState, IMemberList, defaultDirectoryModel } from './classes';
import { ActionType } from './actions';
import * as _ from 'lodash';

export interface IDirectoryStateAction {
  type: ActionType;
  value?: any;
}


// Returns the new directory state given a particular action; this is where all of the application logic resides
export function reduce( state: IDirectoryState<IMember> = defaultDirectoryModel, action: IDirectoryStateAction ) {
  switch ( action.type ) {
    case ActionType.ApplyMemberNameFilter: {
      return _.assign( {}, state, {
        currentPage: 0, nameFilter: action.value
      } ) as IDirectoryState<IMember>;
    }

    case ActionType.ApplyBusinessNameFilter: {
      return _.assign( {}, state, {
        currentPage: 0, businessFilter: action.value
      } ) as IDirectoryState<IMember>;
    }

    case ActionType.ApplyCategoryFilter: {
      if ( action.value != "Select a Category" ) {
        return _.assign( {}, state, {
          currentPage: 0, categoryFilter: action.value
        } ) as IDirectoryState<IMember>;

      } else {
        return _.assign( {}, state, {
          currentPage: 0, categoryFilter: ''
        } ) as IDirectoryState<IMember>;
      }

    }

    case ActionType.MembersUpdated: {
      return _.assign( {}, state, { updating: false } ) as IDirectoryState<IMember>;
    }

    case ActionType.LoadMembers: {
      return _.assign( {}, state, { updating: false, memberList: action.value, filteredMemberList: action.value } ) as IDirectoryState<IMember>;
    }

    case ActionType.ResetFilters: {
      return _.assign( {}, state, { currentPage: 0, filteredMemberList: state.memberList, nameFilter: '', businessFilter: '', categoryFilter: '', updating: true } ) as IDirectoryState<IMember>;
    }

    case ActionType.GoToPage: {
      return _.assign( {}, state, { currentPage: action.value - 1, updating: true } ) as IDirectoryState<IMember>;
    }

    case ActionType.PrevPage: {
      return _.assign( {}, state, { currentPage: ( state.currentPage - 1 ), updating: true } ) as IDirectoryState<IMember>;
    }

    case ActionType.NextPage: {
      return _.assign( {}, state, { currentPage: ( state.currentPage + 1 ), updating: true } ) as IDirectoryState<IMember>;
    }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/directory-reducer.ts